module.exports = __webpack_public_path__ + "static/img/kjfw_3.e96416df.png";